/**
 * Handles all form interactions.
 */
export default class Forms {
  constructor() {
    const formFieldActions = document.querySelectorAll(
      '.form-field .form-field__action',
    );
    const formFieldShowPwd = document.querySelectorAll(
      '.form-field .form-field__label-action',
    );
    const formFieldNumber = document.querySelectorAll(
      '.form-field .form-field__input--number',
    );

    const toggleBtns = document.querySelectorAll('.btn-toggle.sg');
    const searchBtns = document.querySelectorAll('.search .search__toggle');

    formFieldActions.forEach((action) => {
      action.addEventListener('click', this.clearInput);
    });

    formFieldShowPwd.forEach((action) => {
      const input = action
        .closest('.form-field')
        .querySelector('.form-field__input');

      action.addEventListener('click', (e) =>
        this.togglePwdVisibility(action, input),
      );
    });

    formFieldNumber.forEach((input) => {
      input.previousElementSibling.addEventListener('click', () =>
        this.decrementNumber(input),
      );
      input.nextElementSibling.addEventListener('click', () =>
        this.incrementNumber(input),
      );

      this.validateNumber(input);
      input.addEventListener('input', () => this.validateNumber(input));
    });

    toggleBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.toggle(btn));
    });

    searchBtns.forEach((btn) => {
      btn.addEventListener('click', () =>
        this.toggleSearch(btn.parentElement, btn.previousElementSibling),
      );
    });
  }

  /**
   * Handles the clear-event of the input.
   * @param {Event} e
   */
  clearInput(e) {
    e.preventDefault();
    e.stopPropagation();

    const input = e.target.previousElementSibling;

    input.value = '';
    input.focus();
  }

  /**
   * Toggles the visibility of the password input.
   * @param {Element} btn
   * @param {Element} input
   */
  togglePwdVisibility(btn, input) {
    if (input.type === 'password') {
      input.type = 'text';
      btn.classList.add('active');
    } else {
      input.type = 'password';
      btn.classList.remove('active');
    }
  }

  /**
   * Decrements the value in a number-input.
   * @param {Element} input
   */
  decrementNumber(input) {
    const value = Number(input.value);
    input.value = value - 1;

    this.validateNumber(input);
  }

  /**
   * Increments the value in a number-input.
   * @param {Element} input
   */
  incrementNumber(input) {
    const value = Number(input.value);
    input.value = value + 1;

    this.validateNumber(input);
  }

  /**
   * Validates a number input and disables controls if necessary.
   * @param {Element} input
   */
  validateNumber(input) {
    if (input.min) {
      if (Number(input.value) <= Number(input.min)) {
        input.previousElementSibling.setAttribute('disabled', true);
      } else {
        input.previousElementSibling.removeAttribute('disabled');
      }
    }

    if (input.max) {
      if (Number(input.value) >= Number(input.max)) {
        input.nextElementSibling.setAttribute('disabled', 'true');
      } else {
        input.nextElementSibling.removeAttribute('disabled');
      }
    }
  }

  /**
   * Toggles the current button
   * @param {Element} el
   */
  toggle(el) {
    el.classList.toggle('active');
  }

  toggleSearch(el, input) {
    if (el.classList.contains('active')) {
      el.classList.remove('active');
    } else {
      el.classList.add('active');
      input.focus();
    }
  }
}
